import { render, staticRenderFns } from "./jumpGet.vue?vue&type=template&id=cc10f5d4&scoped=true&"
import script from "./jumpGet.vue?vue&type=script&lang=js&"
export * from "./jumpGet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc10f5d4",
  null
  
)

export default component.exports